import { useDispatch } from 'react-redux';
import { notification } from '~/ducks/snackbarNotifications';
import { selectors } from '~/ducks/approvalRequired';
import { getStoreRef } from '~/utils/storeRef';

interface Props {
  type: 'success' | 'info' | 'warning' | 'error';
  message: string;
  duration?: number;
}

const useNotify = () => {
  const dispatch = useDispatch();
  return ({ type, message, duration = 2000 }: Props) => {
    const approvalCaseId = selectors.getApprovalCaseId(getStoreRef()?.getState());
    if ((type === 'success' || type === 'info') && approvalCaseId) return;
    dispatch(notification({ severity: type, message, autoHideDuration: duration }));
  };
};

export default useNotify;
